import { render } from "./ActionSet.vue?vue&type=template&id=3887c257"
import script from "./ActionSet.vue?vue&type=script&lang=js"
export * from "./ActionSet.vue?vue&type=script&lang=js"
script.render = render

export default script